import { AppUtils } from '../../../shared/utils/index';

export class CcmConfiguratorModel {

	private traveling: boolean;
	private saving: boolean;
	private protecting: boolean;
	private checkStateCardColorBlack: boolean;
	private checkStateCardColorPetrol: boolean;
	private platinum: boolean;

	get Traveling() {
		return this.traveling;
	}

	set Traveling(value) {
		this.traveling = value;
	}

	get Saving() {
		return this.saving;
	}

	set Saving(value) {
		this.saving = value;
	}

	get Protecting() {
		return this.protecting;
	}

	set Protecting(value) {
		this.protecting = value;
	}

	get Platinum() {
		return this.platinum;
	}

	set Platinum(value) {
		this.platinum = value;
	}

	get CheckStateCardColorBlack() {
		return this.checkStateCardColorBlack;
	}

	set CheckStateCardColorBlack(value) {
		this.checkStateCardColorBlack = value;
	}

	get CheckStateCardColorPetrol() {
		return this.checkStateCardColorPetrol;
	}

	set CheckStateCardColorPetrol(value) {
		this.checkStateCardColorPetrol = value;
	}


	/**
	* Creates a new CcmCalculatorModel object and copies the values from the provided data object (or other calculator model) to the created CcmCalculatorModel.
	*/
	public static createFromObject(dataObject: { [key: string]: any }): CcmConfiguratorModel {
		return AppUtils.Helper.createFromMap(dataObject, CcmConfiguratorModel);
	}
}
